(function () {
  function initVideoTestimonials(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll('[data-vtest-player]').forEach(function (wrap) {
      if (wrap.dataset.vtestInit === '1') return;
      wrap.dataset.vtestInit = '1';

      var poster = wrap.querySelector('.js-vtest-poster');
      var videoHost = wrap.querySelector('.js-vtest-video');
      var btn = wrap.querySelector('.js-vtest-play');
      if (!poster || !videoHost || !btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        wrap.classList.add('is-playing');
        videoHost.hidden = false;

        var iframe = videoHost.querySelector('iframe[data-deferred-play-src]');
        if (iframe) {
          var playSrc = iframe.getAttribute('data-deferred-play-src');
          if (playSrc && iframe.getAttribute('src') !== playSrc) {
            iframe.setAttribute('src', playSrc);
          }
        }

        var vid = videoHost.querySelector('video');
        if (vid && typeof vid.play === 'function') {
          vid.muted = false;
          vid.play().catch(function () {});
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVideoTestimonials(document);
    });
  } else {
    initVideoTestimonials(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initVideoTestimonials(e.target);
  });
})();
